import { useEffect, useState } from "react";
import axios from "axios";
export default function ShowMessages() {

  const [messages, setMessages] = useState([]);
  const [msg, setMsg] = useState("");
const token = localStorage.getItem("token"); 

  //search 
  const [search, setSearch] = useState("");


  const loadMessages = () => {
    axios
      .get(`/api/messages`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => setMessages(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    loadMessages();
  }, []);

  const DeleteMessage = (id) => {

    if (!window.confirm("Da li sigurno želiš da obrišeš poruku??")) return;

    axios
      .delete(`/api/messages/${id}` , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(() => {
        setMsg("Poruka obrisana ✅");
        loadMessages(); // refresh lista
      })
      .catch(() => setMsg("Greška pri brisanju ❌"));
  };

    const MessageFlagYES = (id) => {
    axios
        .put(`/api/messages/${id}/flag/1` , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
        .then(() => {
        setMsg("Poruka markirana: ✅");
        loadMessages(); // refresh lista
        })
        .catch(() => setMsg("Greška pri update ❌"));
    };

    const MessageFlagNO = (id) => {
    axios
        .put(`/api/messages/${id}/flag/0` , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
        .then(() => {
        setMsg("Poruka markirana: ❌");
        loadMessages(); // refresh lista
        })
        .catch(() => setMsg("Greška pri update ❌"));
    };


    // Filtrirana lista po search inputu
    const filteredMessages = (messages || []).filter(m =>
      (m?.body || "").toLowerCase().includes(search.toLowerCase()) ||
      (m?.email || "").toLowerCase().includes(search.toLowerCase()) ||
      (m?.ime || "").toLowerCase().includes(search.toLowerCase())
    );

  return (
    <div className="card bg-dark text-white p-4">
      <h4>Poruke</h4>

      {/* LOKALNI SEARCH */}
      <input
        type="text"
        className="form-control mb-3 w-25"
        placeholder="Search by context or data..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />


      {msg && <p>{msg}</p>}
        <div className="table-responsive-lg position-relative">
            <table className="table table-dark-wh">
                <thead>
                    <tr>
                        <th>Text</th>
                        <th>Email</th>
                        <th>Klijent</th>
                        <th>Datum</th>
                        <th>Odgovoreno</th>                        
                        <th >ActionsYesNo</th>
                        <th>Delete</th>
                    </tr>
                </thead>

                <tbody>
                {filteredMessages.map(m => (
                    <tr key={m.porukaID}>
                        <th>{m.body}</th>
                        <th>{m.email}</th>
                        <th>{m.ime}</th>
                        <th>{m.datum}</th>
                        <th>
                        {m.flag === 0 ? "-" : "✔️"}
                        </th>
                        <td>
                            <button
                            className="btn btn-neutral btn-sm"
                            onClick={() => MessageFlagYES(m.porukaID)}
                            >
                            ✅
                            </button>

                            <button
                            className="btn btn-neutral btn-sm"
                            onClick={() => MessageFlagNO(m.porukaID)}
                            >
                            ❌
                            </button>
                        </td>
                        <td>
                            <button
                            className="btn btn-danger btn-sm"
                            onClick={() => DeleteMessage(m.porukaID)}
                            >
                            🗑️
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    </div>
  );
}